import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api, setTokens, clearTokens } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const load = useCallback(async () => {
    // Returning from Google OAuth: AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    if (!localStorage.getItem("s7_at")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);
  const login = async (email, password, portal) => {
    const { data } = await api.post("/auth/login", { email, password, portal });
    setTokens(data);
    setUser(data.user);
    return data.user;
  };
  const register = async (body) => {
    const { data } = await api.post("/auth/register", body);
    setTokens(data);
    setUser(data.user);
    return data.user;
  };
  const logout = () => { clearTokens(); setUser(false); };
  return <Ctx.Provider value={{ user, setUser, login, register, logout, reload: load }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);

export function RequireRole({ roles, children, loginPath }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen bg-white" data-testid="auth-loading" />;
  if (!user || !roles.includes(user.role)) return <Navigate to={loginPath} state={{ from: loc.pathname }} replace />;
  return children;
}
